module.exports = __webpack_public_path__ + "static/media/github-icon.767e15a2.svg";